import * as ambassadorWixFastgalleryDraftitemV1DraftItem from './fastgallery-draftitem-v1-draft-item-draft-items.http.js';
import * as ambassadorWixFastgalleryDraftitemV1DraftItemTypes from './fastgallery-draftitem-v1-draft-item-draft-items.types.js';
import * as ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes from './fastgallery-draftitem-v1-draft-item-draft-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDraftItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.CreateDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.CreateDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.CreateDraftItemResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.CreateDraftItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.createDraftItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDraftItem(): __PublicMethodMetaInfo<
  'GET',
  { draftItemId: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.GetDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.GetDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.GetDraftItemResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.GetDraftItemResponse
> {
  const payload = { draftItemId: ':draftItemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.getDraftItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/draft-items/{draftItemId}',
    pathParams: { draftItemId: 'draftItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDraftItem(): __PublicMethodMetaInfo<
  'PATCH',
  { draftItemId: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.UpdateDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.UpdateDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.UpdateDraftItemResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.UpdateDraftItemResponse
> {
  const payload = { draftItem: { id: ':draftItemId' } } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.updateDraftItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/draft-items/{draftItem.id}',
    pathParams: { draftItemId: 'draftItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDraftItem(): __PublicMethodMetaInfo<
  'DELETE',
  { draftItemId: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.DeleteDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.DeleteDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.DeleteDraftItemResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.DeleteDraftItemResponse
> {
  const payload = { draftItemId: ':draftItemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.deleteDraftItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/draft-items/{draftItemId}',
    pathParams: { draftItemId: 'draftItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDraftItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.QueryDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.QueryDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.QueryDraftItemsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.QueryDraftItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.queryDraftItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/draft-items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.UpdateExtendedFieldsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-items/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateDraftItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.BulkCreateDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.BulkCreateDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.BulkCreateDraftItemsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.BulkCreateDraftItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.bulkCreateDraftItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/draft-items/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDraftItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.BulkUpdateDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.BulkUpdateDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.BulkUpdateDraftItemsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.BulkUpdateDraftItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.bulkUpdateDraftItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/draft-items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteDraftItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.BulkDeleteDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.BulkDeleteDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.BulkDeleteDraftItemsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.BulkDeleteDraftItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.bulkDeleteDraftItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/draft-items/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDraftItemFromTrashBin(): __PublicMethodMetaInfo<
  'DELETE',
  { draftItemId: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.RemoveDraftItemFromTrashBinRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.RemoveDraftItemFromTrashBinRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.RemoveDraftItemFromTrashBinResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.RemoveDraftItemFromTrashBinResponse
> {
  const payload = { draftItemId: ':draftItemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.removeDraftItemFromTrashBin(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/draft-items/trash-bin/{draftItemId}',
    pathParams: { draftItemId: 'draftItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreDraftItemFromTrashBin(): __PublicMethodMetaInfo<
  'POST',
  { draftItemId: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.RestoreDraftItemFromTrashBinRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.RestoreDraftItemFromTrashBinRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.RestoreDraftItemFromTrashBinResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.RestoreDraftItemFromTrashBinResponse
> {
  const payload = { draftItemId: ':draftItemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.restoreDraftItemFromTrashBin(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-items/trash-bin/{draftItemId}/restore',
    pathParams: { draftItemId: 'draftItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeletedDraftItem(): __PublicMethodMetaInfo<
  'GET',
  { draftItemId: string },
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.GetDeletedDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.GetDeletedDraftItemRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.GetDeletedDraftItemResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.GetDeletedDraftItemResponse
> {
  const payload = { draftItemId: ':draftItemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.getDeletedDraftItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/draft-item/trash-bin/{draftItemId}',
    pathParams: { draftItemId: 'draftItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeletedDraftItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.ListDeletedDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.ListDeletedDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.ListDeletedDraftItemsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.ListDeletedDraftItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.listDeletedDraftItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/draft-items/trash-bin',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function moveDraftItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.MoveDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.MoveDraftItemsRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.MoveDraftItemsResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.MoveDraftItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.moveDraftItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/draft-items/move-after',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sortDraftItemsBy(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.SortDraftItemsByRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.SortDraftItemsByRequest,
  ambassadorWixFastgalleryDraftitemV1DraftItemUniversalTypes.SortDraftItemsByResponse,
  ambassadorWixFastgalleryDraftitemV1DraftItemTypes.SortDraftItemsByResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryDraftitemV1DraftItem.sortDraftItemsBy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/draft-items/sort-by',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DraftItem as DraftItemOriginal,
  Link as LinkOriginal,
  LinkType as LinkTypeOriginal,
  LinkTypeWithLiterals as LinkTypeWithLiteralsOriginal,
  WixLink as WixLinkOriginal,
  WixLinkLinkOneOf as WixLinkLinkOneOfOriginal,
  ExternalLink as ExternalLinkOriginal,
  LinkRel as LinkRelOriginal,
  LinkRelWithLiterals as LinkRelWithLiteralsOriginal,
  PageLink as PageLinkOriginal,
  AnchorLink as AnchorLinkOriginal,
  DynamicPageLink as DynamicPageLinkOriginal,
  DocumentLink as DocumentLinkOriginal,
  EmailLink as EmailLinkOriginal,
  PhoneLink as PhoneLinkOriginal,
  AddressLink as AddressLinkOriginal,
  WhatsAppLink as WhatsAppLinkOriginal,
  TpaPageLink as TpaPageLinkOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemMediaOneOf as MediaItemMediaOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Image as ImageOriginal,
  CommonImage as CommonImageOriginal,
  FocalPoint as FocalPointOriginal,
  Point as PointOriginal,
  UnsharpMasking as UnsharpMaskingOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ReorderedDraftItem as ReorderedDraftItemOriginal,
  CreateDraftItemRequest as CreateDraftItemRequestOriginal,
  CreateDraftItemResponse as CreateDraftItemResponseOriginal,
  GetDraftItemRequest as GetDraftItemRequestOriginal,
  GetDraftItemResponse as GetDraftItemResponseOriginal,
  UpdateDraftItemRequest as UpdateDraftItemRequestOriginal,
  UpdateDraftItemResponse as UpdateDraftItemResponseOriginal,
  DeleteDraftItemRequest as DeleteDraftItemRequestOriginal,
  DeleteDraftItemResponse as DeleteDraftItemResponseOriginal,
  QueryDraftItemsRequest as QueryDraftItemsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryDraftItemsResponse as QueryDraftItemsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  BulkCreateDraftItemsRequest as BulkCreateDraftItemsRequestOriginal,
  BulkCreateDraftItemsResponse as BulkCreateDraftItemsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkDraftItemResult as BulkDraftItemResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateDraftItemsRequest as BulkUpdateDraftItemsRequestOriginal,
  MaskedDraftItem as MaskedDraftItemOriginal,
  BulkUpdateDraftItemsResponse as BulkUpdateDraftItemsResponseOriginal,
  BulkUpdateDraftItemsResponseBulkDraftItemResult as BulkUpdateDraftItemsResponseBulkDraftItemResultOriginal,
  BulkDeleteDraftItemsRequest as BulkDeleteDraftItemsRequestOriginal,
  BulkDeleteDraftItemsResponse as BulkDeleteDraftItemsResponseOriginal,
  BulkDeleteDraftItemsResponseBulkDraftItemResult as BulkDeleteDraftItemsResponseBulkDraftItemResultOriginal,
  RemoveDraftItemFromTrashBinRequest as RemoveDraftItemFromTrashBinRequestOriginal,
  RemoveDraftItemFromTrashBinResponse as RemoveDraftItemFromTrashBinResponseOriginal,
  RestoreDraftItemFromTrashBinRequest as RestoreDraftItemFromTrashBinRequestOriginal,
  RestoreDraftItemFromTrashBinResponse as RestoreDraftItemFromTrashBinResponseOriginal,
  GetDeletedDraftItemRequest as GetDeletedDraftItemRequestOriginal,
  GetDeletedDraftItemResponse as GetDeletedDraftItemResponseOriginal,
  ListDeletedDraftItemsRequest as ListDeletedDraftItemsRequestOriginal,
  ListDeletedDraftItemsResponse as ListDeletedDraftItemsResponseOriginal,
  MoveDraftItemsRequest as MoveDraftItemsRequestOriginal,
  MoveDraftItemsResponse as MoveDraftItemsResponseOriginal,
  DraftItemNotFoundError as DraftItemNotFoundErrorOriginal,
  DraftItemNotInGalleryError as DraftItemNotInGalleryErrorOriginal,
  SortDraftItemsByRequest as SortDraftItemsByRequestOriginal,
  SortByFieldSorting as SortByFieldSortingOriginal,
  SortableFieldNames as SortableFieldNamesOriginal,
  SortableFieldNamesWithLiterals as SortableFieldNamesWithLiteralsOriginal,
  SortDraftItemsByResponse as SortDraftItemsByResponseOriginal,
  DraftItemSortUnsupportedError as DraftItemSortUnsupportedErrorOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  MoveDraftItemsApplicationErrors as MoveDraftItemsApplicationErrorsOriginal,
  SortDraftItemsByApplicationErrors as SortDraftItemsByApplicationErrorsOriginal,
} from './fastgallery-draftitem-v1-draft-item-draft-items.types.js';
